module.exports = __webpack_public_path__ + "static/media/quality-03.2f3cde86.jpg";